// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MbSFz","textarea":"styles_textarea__2kqk1"};